import validate from "/home/runner/work/dashboard/dashboard/node_modules/.pnpm/nuxt@3.20.2_@parcel+watcher@2.5.1_@types+node@25.0.0_@vue+compiler-sfc@3.5.25_cac@6.7.1_595b8f28fae60f73359915e863793472/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45login_45domain_45global from "/home/runner/work/dashboard/dashboard/middleware/01.loginDomain.global.ts";
import _02_45auth_45global from "/home/runner/work/dashboard/dashboard/middleware/02.auth.global.ts";
import hide_45submenu_45global from "/home/runner/work/dashboard/dashboard/middleware/hideSubmenu.global.ts";
import manifest_45route_45rule from "/home/runner/work/dashboard/dashboard/node_modules/.pnpm/nuxt@3.20.2_@parcel+watcher@2.5.1_@types+node@25.0.0_@vue+compiler-sfc@3.5.25_cac@6.7.1_595b8f28fae60f73359915e863793472/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45login_45domain_45global,
  _02_45auth_45global,
  hide_45submenu_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}